import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Cliente } from '../../../../../models/generar_pedido/DataUser';
import { ClientePedidoService } from '../../../../../services/generar-pedido/cliente-pedido.service';
import { BusquedaProductosService } from '../utils/services/busqueda-productos.service';
import { EmpresaService } from '../../../../../services/Empresa/Empresa.service';
import { LoginService } from '../../../../../services/login/login.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SwalService } from '../../../../../services/swal/swal.service';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements OnInit {
  @Input() kabicoinsCliente: string = "0";
  @Input('categorizacionCliente') categoriaCliente: string = "";

  empresaId: number = 0;
  clienteSub: Subscription;
  cliente$: Cliente;
  busqueda = new FormControl('', Validators.required)
  productos: any[] = [];
  totalProductos: number;
  selectedTab: number = 1;
  paginas: number = 0;
  ordenSeleccionado: string = "H";
  orden: string = "";
  marcas: any[] = [];
  grupos: any[] = [];
  marcaSeleccionada: string = "";
  grupoSeleccionado: string = "";
  cargando: boolean = false;
  expandir: boolean = true;

  // Integracion con buscador y autocompletado
  terminoBuscado: string;
  soluciones: string;
  departamento: string;

  sugerido: boolean = false;

  tipoOrden: any[] = [
    { value: "A", viewValue: "Precio Menor" },
    { value: "B", viewValue: "Precio Mayor" },
    { value: "C", viewValue: "Clave [A-Z]" },
    { value: "D", viewValue: "Clave [Z-A]" },
    { value: "E", viewValue: "Descripción [A-Z]" },
    { value: "F", viewValue: "Descripción [Z-A]" },
    { value: "G", viewValue: "Existencias Tampico Menor a Mayor" },
    { value: "H", viewValue: "Existencias Tampico Mayor a Menor" },
    { value: "I", viewValue: "Existencias CDMX Menor a Mayor" },
    { value: "J", viewValue: "Existencias CDMX Mayor a Menor" },
  ]

  constructor(
    private clientePedido: ClientePedidoService,
    private busquedaService: BusquedaProductosService,
    private empresaService: EmpresaService,
    private loginService: LoginService,
    private swal: SwalService
  ) { }

  ngOnInit(): void {
    this.empresaId = this.empresaService.getEmpresaId();
    
    if(this.empresaId == 2) {
      this.tipoOrden = this.tipoOrden.map((item) => {
        if(item.value == "G" || item.value == "H") {
          return {value: item.value, viewValue: item.viewValue.replace(" Tampico", "")};
        }
        return item;
      })
    }

    this.clienteSub = this.clientePedido.cliente$.subscribe((cliente) => {
      this.cliente$ = cliente;
      if (cliente.ClienteID == '') {
        this.clear();
      }
    });

  }

  getSearchIndex(index: number): void {
    this.selectedTab = index + 1;
  }

  search() {
    this.cargando = true;
    this.busquedaService.search(this.terminoBuscado, 'K', this.selectedTab, this.marcaSeleccionada, this.grupoSeleccionado, "0", this.sugerido)
      .subscribe(
        result => {
          if (result.productos.length == 0) {
            Swal.fire({
              text: 'No se encontraron resultados.',
              toast: true,
              timer: 4000,
              confirmButtonText: 'Aceptar',
              position: 'top',
            })
          }

          this.productos = result.productos;
          this.totalProductos = result.total;
          this.marcas = result.marcas;
          this.grupos = result.grupos;
          this.paginas = Math.ceil(this.totalProductos / this.productos.length);
          // console.log(this.totalProductos, this.productos.length, this.paginas)
          // console.log("RESULTADOS PRODUCTOS:", this.productos, this.totalProductos);
          this.cargando = false;
          this.expandir = true;
        },
        error => {
          console.error(error);
          this.swal.swalError('Error', `Ha ocurrido un error al obtener los resultados, intente nuevamente. Si el error persiste, favor de reportarlo al administrador. \n\n ${error.message}`);
          this.cargando = false;
        }
      );
  }

  searchAutocompletado() {
    this.cargando = true;
    this.busquedaService.searchEspecifica(this.selectedTab, 'K', this.departamento, this.grupoSeleccionado, this.marcaSeleccionada, 0, this.soluciones)
      .subscribe(
        result => {
          if (result.productos.length == 0) {
            Swal.fire({
              text: 'No se encontraron resultados.',
              toast: true,
              timer: 4000,
              confirmButtonText: 'Aceptar',
              position: 'top',
            })
          }

          this.productos = result.productos;
          this.totalProductos = result.total;
          this.marcas = result.marcas;
          this.grupos = result.grupos;
          this.paginas = Math.ceil(this.totalProductos / this.productos.length);
          this.cargando = false;
          this.expandir = true;
        },
        error => {
          this.swal.swalError('Error', `Ha ocurrido un error al obtener los resultados, intente nuevamente. Si el error persiste, favor de reportarlo al administrador. \n\n ${error.message}`);
          this.cargando = false;
        }
      )
  }

  buscarProductos(busqueda: any) {
    if (this.cliente$.ClienteID == '') {
      Swal.fire({
        text: 'Selecciona un cliente antes de proceder.',
        toast: true,
        timer: 5000,
        position: 'top',
        
      })
      return
    }

    this.sugerido = false;
    this.soluciones = '';
    this.departamento = '';
    this.marcaSeleccionada = '';

    if (typeof busqueda == 'string') {
      // Realizar busqueda normal
      // console.log(busqueda, "viene de texto")
      this.terminoBuscado = busqueda;
      this.searchLimpia();
    } else if (busqueda instanceof Object) {
      switch (busqueda.tipo) {
        case 'autocompletado':
          // Realizar busqueda con termino sugerido
          // console.log(busqueda, "viene de autocompletado")
          this.terminoBuscado = busqueda.item;
          this.sugerido = true;
          this.searchLimpia();
          break;
        case 'categoria':
          // Realizar busqueda por categoria
          // console.log(busqueda, "viene de categoria")
          this.departamento = busqueda.item.id;
          this.soluciones = busqueda.item.pathUrl;
          this.searchLimpia();
          break;
        case 'marca':
          // Realizar busqueda por marca
          // console.log(busqueda, "viene de marca")
          this.marcaSeleccionada = busqueda.item.MarcaID;
          this.soluciones = busqueda.item.Nombre;
          this.searchLimpia()
          break;
      }
    }
  }

  searchLimpia() {
    this.grupoSeleccionado = "";
    this.selectedTab = 1;
    if (this.soluciones != '') {
      this.searchAutocompletado();
    } else {
      this.marcaSeleccionada = "";
      this.search();
    }
  }

  onGrupoChange(event: any, grupo: string) {
    if (event.checked) {
      this.grupoSeleccionado = grupo;
    } else {
      this.grupoSeleccionado = ""
    }
    if (this.soluciones == '') {
      this.search();
    } else {
      this.searchAutocompletado();
    }
  }

  onMarcaChange(event: any, marca: string) {
    if (event.checked) {
      this.marcaSeleccionada = marca;
    } else {
      this.marcaSeleccionada = ""
    }
    if (this.soluciones == '') {
      this.search();
    } else {
      this.searchAutocompletado();
    }
  }

  cambioPagina(index: number): void {
    this.getSearchIndex(index);
    this.search();
    this.scrollToTop();
  }

  scrollToTop(): void {
    const dialogContent = document.querySelector('.mat-dialog-container');
    if (dialogContent) {
      dialogContent.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  clear() {
    //this.busqueda.setValue('');
    this.totalProductos = 0;
    this.grupoSeleccionado = '';
    this.grupos = [];
    this.marcaSeleccionada = '';
    this.marcas = [];
    this.productos = [];
    this.selectedTab = 1;
    this.paginas = 0;
    this.ordenSeleccionado = "H";
    this.orden = "";
  }
}
